// extracted by mini-css-extract-plugin
export default {"cls1":"Ax7fbmUtzixugro_dkCE","cls2":"i2rqWU_QWCdkw8xrxYXC Ax7fbmUtzixugro_dkCE"};